<div
  class="absolute top-0 bottom-0 flex w-full flex-col items-center justify-center">
  <div class="pb-4 text-3xl font-bold">
    {{
      textStore.texts()
        | filterTexts: ERelationType.accessDenied : EEntityType.generic
        | language
    }}
  </div>
  <a [routerLink]="'/'" class="text-input-focus text-xl font-semibold">{{
    textStore.texts()
      | filterTexts: ERelationType.backToShop : EEntityType.generic
      | language
  }}</a>
</div>
